import { defineMessages } from 'react-intl';

export default defineMessages({
  landingPageTitle: {
    id: 'report.landingPage.Title',
    defaultMessage: 'Exciting news for reporting',
  },
  landingPageFirstDescription: {
    id: 'report.landingPage.FirstDescription',
    defaultMessage: 'We’re excited to share with you that we have a new reporting experience!',
  },
  landingPageSecondDescription: {
    id: 'report.landingPage.SecondDescription',
    defaultMessage:
      'You can now switch to new report experience, or stay in the current experience. We appreciate your feedback on the new experience.',
  },
  landingPageNewReportExperience: {
    id: 'report.landingPage.NewReportExperience',
    defaultMessage: 'New report experience',
  },
  landingPageCurrentReport: {
    id: 'report.landingPage.CurrentReport',
    defaultMessage: 'Current report',
  },
  landingPageFirstSectionTitle: {
    id: 'report.landingPage.FirstSection.Title',
    defaultMessage: 'Speedier Report Generation',
  },
  landingPageFirstSectionDescription: {
    id: 'report.landingPage.FirstSection.Description',
    defaultMessage: 'Reports now generate more quickly, helping you access your data sooner.',
  },
  landingPageSecondSectionTitle: {
    id: 'report.landingPage.SecondSection.Title',
    defaultMessage: 'Report Customization',
  },
  landingPageSecondSectionDescription: {
    id: 'report.landingPage.SecondSection.Description',
    defaultMessage: 'Customize your reports with new options to adjust metrics and dimensions to your needs.',
  },
  landingPageThirdSectionTitle: {
    id: 'report.landingPage.ThirdSection.Title',
    defaultMessage: 'Refreshed Interface',
  },
  landingPageThirdSectionDescription: {
    id: 'report.landingPage.ThirdSection.Description',
    defaultMessage: `We've made some improvements for a smoother, more straightforward experience.`,
  },
});
